
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.898 6.57h-8.93l1.259 1.508-.508.43-3.82-3.82v-.5l3.82-3.82.508.429-1.25 1.492h8.921v1.04H3.18L2.28 4.436l.883 1.094h9.734v1.04z","fill":"currentColor"}})])
          )
        }
      }
    